// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"25386": "df583e87","26305": "f3af7d77","67416": "8e963296","7658": "3505e50f","89066": "47e4a6fa","89890": "3115f66c","91775": "3de80f3d",}[chunkId] + ".css"
}